<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <rect
      x="4"
      y="11"
      width="16"
      height="10"
      rx="2.5"
      fill="currentColor"
      fill-opacity=".25"
    />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
</template>

<script>
export default {
  name: 'IconLockOutline',
  props: {
    size: { type: [String, Number], default: 18 },
    strokeWidth: { type: [String, Number], default: 2.4 },
  },
};
</script>
